import Modal from 'react-bootstrap/Modal';
import { FaTrashAlt } from 'react-icons/fa';
import ActionButtonGradient from '../button/ActionButtonGradient';

const DeleteModal = ({show, handleClose, handleOk, title}) => {
  return (
    <>
      <style>
        {`
          .delete-modal .modal-content {
            border: none;
            border-radius: 12px;
            box-shadow: 0 10px 25px rgba(0,0,0,0.15);
          }
          .delete-modal .modal-header {
            border-bottom: 1px solid #e9ecef;
            padding: 1.5rem 1.5rem 1rem 1.5rem;
            background-color: #fff;
            border-radius: 12px 12px 0 0;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .delete-modal .modal-title {
            font-weight: 600;
            color: #333;
            font-size: 1.125rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            margin: 0;
          }
          .delete-modal .modal-body {
            padding: 1rem 1.5rem 1.5rem 1.5rem;
            background-color: #fff;
            font-size: 14px;
            color: #666;
            line-height: 1.5;
            text-align: center;
          }
          .delete-modal .modal-footer {
            border-top: 1px solid #e9ecef;
            padding: 1rem 1.5rem 1.5rem 1.5rem;
            background-color: #fff;
            border-radius: 0 0 12px 12px;
            display: flex;
            gap: 0.5rem;
            justify-content: center;
          }
          .delete-modal .btn {
            border-radius: 8px;
            padding: 0.5rem 1.25rem;
            font-weight: 500;
            font-size: 14px;
            transition: all 0.2s ease;
          }
          .delete-modal .btn-danger {
            background-color: #dc3545;
            border-color: #dc3545;
            color: white;
          }
          .delete-modal .btn-danger:hover {
            background-color: #c82333;
            border-color: #bd2130;
            transform: translateY(-1px);
            box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);
          }
          .delete-modal .btn-secondary {
            background-color: #6c757d;
            border-color: #6c757d;
            color: white;
          }
          .delete-modal .btn-secondary:hover {
            background-color: #5a6268;
            border-color: #545b62;
            transform: translateY(-1px);
            box-shadow: 0 2px 8px rgba(108, 117, 125, 0.3);
          }
          .delete-icon {
            color: #dc3545;
            font-size: 1.125rem;
          }
        `}
      </style>
      
      <Modal 
        show={show} 
        onHide={handleClose}
        backdrop="static" 
        centered
        size="md"
        className="delete-modal"
      >
        <Modal.Header>
          <Modal.Title>
            <FaTrashAlt className="delete-icon" />
            Delete Confirmation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-0">Are you sure you want to delete <strong>{title}</strong>?</p>
          <p className="mb-0">This action cannot be undone.</p>
        </Modal.Body>
        <Modal.Footer>
          <ActionButtonGradient
            onClick={handleClose}
            variant='secondary'
            children={"Cancel"}
          />
          <ActionButtonGradient
            onClick={handleOk}
            variant='danger'
            children={"Delete"}
          />
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default DeleteModal